// APIのベースURL。
// custom-client / file-download-client / libs/api から参照される。
// libs/api が custom-client に依存できるよう、循環参照を避けるためにここへ切り出している。
export const baseURL = import.meta.env.VITE_API_BASE_URL || 'http://127.0.0.1:8000';
